import axios from 'axios';

class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    }

    this.selectors = {
      cartDrawerContainer: '#cart-drawer-container'
    }

    this.state = {
      showedCard: false
    }
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      }
    }
    window.dispatchEvent(new CustomEvent(event_name, contents))
  }

  add(data) {
    return new Promise((resolve, reject) => {
      this.request('add', data).then(({ data }) => {
        this.mergeWithCurrentCart(data)
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_added", true)
        this.update();
        resolve(this.cart)
      }).catch((error) => {
          let err_msg = error.description

          if(err_msg){
            let toast = document.querySelector('.toast')
              toast.classList.add('show')
              toast.querySelector('.toast-content').innerHTML = err_msg

              setTimeout(()=>{
                toast.classList.remove('show')
              },3000)

              toast.querySelector('.close-toast').addEventListener('click', ()=>{
                toast.classList.remove('show')
              })
          }


      })
    });
  }

  get() {
    return new Promise((resolve, reject) => {
      this.request('get').then((response) => {
        this.cart = response.data;
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  updateCartCounter(){
    new Promise((resolve, reject) => {
      this.request('get').then((response) => {
        if(response.data.item_count > 0) {
          if (document.querySelector('.cart-title span')) {
            document.querySelector('.cart-title span').innerHTML = `(${response.data.item_count} items)`
          }
          document.querySelectorAll('.basket .site-header__badge').forEach(el => {
            el.classList.remove('is-hidden')
            el.textContent = response.data.item_count;
          })
        } else {
          document.querySelector('.cart-title span').innerHTML = `(0 items)`
          document.querySelectorAll('.basket .site-header__badge').forEach(el => {
            el.classList.add('is-hidden')
            el.textContent = response.data.item_count;
          })
        }
        
      }).catch((error) => {
        reject(error)
      })
    });
  }

  update(data) {
    return new Promise((resolve, reject) => {
      this.request('update', data).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true);
        this.updateCartCounter();
        let sideCartCount = document.querySelector('#cart-drawer .cart-title span')
        let cartCounter = document.querySelector('.openSideCart .site-header__badge')
        if(sideCartCount) sideCartCount.innerHTML = `(${this.cart.item_count} items)`
        if(cartCounter) cartCounter.innerHTML = `${this.cart.item_count}`
        
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  remove(variant_id) {
    return new Promise((resolve, reject) => {
      let updates = {
        updates: {
          [variant_id]: 0,
        }
      }
      this.request('update', updates).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_removed", true);
        this.updateCartCounter();
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    })
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.request('clear').then(({ data }) => {
        this.cart = data
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("cart_cleared", true);
        this.updateCartCounter();
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  async request(key, data) {
    return new Promise((resolve, reject) => {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      axios({
        method,
        url,
        data,
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        if (error.response) {
          // Request made and server responded
          reject(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          reject(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error.message)
        }
      })
    })
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item)
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        })
        this.dispatchEvent("side_cart_closed", false)
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    const popup = document.querySelector('#cart-drawer-container .cart-popup')
    popup ? popup.classList.remove('showed') : null;
    if (sideCartContainer) {
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      document.body.classList.remove("locked");
      this.dispatchEvent("side_cart_closed", false)
      this.state.showedCard = false;
    }
  }

  // Calls the seciton rendering API to render the v2-side-cart section (with refference to the cart page) and inserts the section html into the side cart
  async reRenderSideCart(successCallback = null) {
    await axios
      .get(" /cart?sections=v2-side-cart", {})
      .then((response) => {
        // Success
        let html = response.data["v2-side-cart"];
        let side_cart_inner = document.querySelector(
          "#cart-drawer-container .inner"
        );

        axios.get("cart.js", {}).then((res)=>{
          res.data.item_count > 1 ?  document.querySelector('.cart-title span').innerHTML = `(${res.data.item_count} items)` : document.querySelector('.cart-title span').innerHTML = `(${res.data.item_count} item)`
        })
       
        if (side_cart_inner && html) {

          side_cart_inner.innerHTML = html;

          // Change free delivery status
          let free_delivery_el = document.querySelector('.free-delivery-status');
          let free_delivery_trigger = free_delivery_el.dataset.freeDelivery;
          // console.log("🚀 ~ file: side_cart_functions.js:59 ~ free_delivery_trigger", free_delivery_trigger)
          let cart_total = document.querySelector('#cart-drawer .sub-total').dataset.subTotal / 100;
          let range = document.querySelector('.delivery-range progress')
          let progress_percent = Math.round(cart_total / free_delivery_trigger * 100)
          range.value = progress_percent
          let rangeAfter = document.querySelector('.delivery-range progress + .dot')
          rangeAfter.style.left = `clamp(0%, ${progress_percent}%, 100%);`
          rangeAfter.setAttribute('style', `left:clamp(0%, ${progress_percent}%, 100%);`)
     
          if (!free_delivery_trigger) {
            free_delivery_el.style.display = 'none';
          } else if (cart_total < free_delivery_trigger) {
            let spend_more = free_delivery_trigger - cart_total;
            spend_more = spend_more.toFixed(2);
            free_delivery_el.innerHTML = `£${spend_more} away from FREE DELIVERY`;
          } else {
            free_delivery_el.innerHTML = `Qualifies for FREE DELIVERY`;
          }

          const loadMoreBtn = document.getElementById('viewBasket');
          if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', (event)=>{
              event.preventDefault();
              const hiddenCards = document.querySelector('.cart').querySelectorAll('.item.hidden-card');
              const allCards = document.querySelector('.cart').querySelectorAll('.item');
              if (!this.state.showedCard && !event.target.classList.contains('active')) {
                if (hiddenCards && hiddenCards.length > 0) {
                  hiddenCards.forEach(card=>{
                    card.classList.remove('hidden-card')
                  })
                }
                event.target.classList.add('active');
                this.state.showedCard = true;
              } else {
                if (allCards && allCards.length > 0) {
                  allCards.forEach((card, index)=>{
                    if(index > 0) {
                      card.classList.add('hidden-card')
                    }
                  })
                }
                event.target.classList.remove('active');
                this.state.showedCard = false;
              }
              
            })
          }


          let first_cart_item = side_cart_inner.querySelector('.item');
          if (first_cart_item) {
            first_cart_item = first_cart_item.dataset.productId;
          }

          // Get recommended products based on first item in side cart
          if (first_cart_item) {
            const productRecommendationsSection = document.querySelector('.cart-recommendations');
            const section_id = productRecommendationsSection.dataset.sectionId;

            // axios.get(`/recommendations/products.json?product_id=${first_cart_item}&limit=5`)
            axios.get(`/recommendations/products?section_id=${section_id}&product_id=${first_cart_item}&limit=5`, {})
              .then((response) => {
                const text = response.data;
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.cart-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  productRecommendationsSection.innerHTML = recommendations.innerHTML;
                  let product_links = productRecommendationsSection.querySelectorAll('.product-link');
                  product_links.forEach((product_link) => {
                    product_link.innerHTML = "View"
                  })

                  const swiper_side_cart_recommended = new window.swiper('.side-cart-recommendations-slider', {
                    slidesPerView: 2.4,
                    spaceBetween: 11,
                    lazy: {
                      enabled: true,
                      checkInView: false,
                      loadOnTransitionStart: true,
                      loadPrevNext: true,
                      loadPrevNextAmount: 1
                    },
                  });

                }
              })
              .catch((error) => {
                window.log(error);
              })

            const popup = document.querySelector('#cart-drawer-container .cart-popup')  
            if(popup) {
              popup ? popup.classList.add('showed') : null;
              popup.querySelector('.close-popup').addEventListener('click', ()=>{
                popup.classList.remove('showed')
              })
              
              const innerContainer = popup.querySelector(".popup-inner")
              new window.swiper(innerContainer, {
                slidesPerView: 3,
                spaceBetween: 21,
                lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
                },
                breakpoints: {
                  1023: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
          
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 21,
                  }
                }
              });
            }
          }
          if (this.state.showedCard) {
            side_cart_inner.querySelectorAll('.item.hidden-card').forEach(card=>{
              card.classList.remove('hidden-card')
            })
          }
          this.cartRenderedEvent(response, html)

          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        window.log("Error:", error);
      })
  }

  reRenderCart() {
    axios
      .get(" /cart?sections=cart-qf", {})
      .then(function (response) {
        let html = response.data["cart-qf"];
        let cart_inner = document.querySelector("#cart-container");
        if (cart_inner && html) {
          cart_inner.innerHTML = html;
          window.VATFuncionality.init();

          this.cartRenderedEvent(response, html)
        }
      })
      .catch(function (error) {
        window.log("Error:", error);
      })
  }

  cartRenderedEvent(response, html) {
    window.VATFuncionality.init();
    window.dispatchEvent(new CustomEvent("cart_rendered", {
      detail: {
        response: response,
        html: html,
      },
    }));
  }
}

// export default new CartQf();
window.CartQf = CartQf;